// Configuration for the single production Supabase project (yyhljkkdktrqkktixjtk)
// Supabase anon keys are designed to be public (security is enforced by RLS)

interface EnvConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
}

export const envConfig: EnvConfig = {
  supabaseUrl: 'https://yyhljkkdktrqkktixjtk.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl5aGxqa2tka3RycWtrdGl4anRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk5ODkzMjksImV4cCI6MjA3NTU2NTMyOX0.wLUGkB4CLBCSns4rSgSN6q_kU9L2pagb3Y8UO_tyAZA',
};
